import { SkipClassificationReason } from '@modules/TasksModule/types';
import ToastModule from '..';
import strings from './strings';

export const showCloseAndClassifyErrorToast = () => {
  ToastModule.showToast({
    status: 'critical',
    title: 'Unable to close and classify call',
    toastBody:
      'Please wait and try again. If the problem persists, log an issue with support.',
  });
};

const titleMap = {
  [SkipClassificationReason.ClassificationCompleted]:
    strings.writeClassificationToasts.successUpsert,
  [SkipClassificationReason.NotRequired]:
    strings.writeClassificationToasts.successUpsert,
  [SkipClassificationReason.NoTenantAccess]:
    strings.writeClassificationToasts.noTenantAccess,
};

export const showCallCompletedToast = (
  skipReason?: SkipClassificationReason,
) => {
  const title =
    titleMap[skipReason ?? SkipClassificationReason.NotRequired] ||
    strings.writeClassificationToasts.successUpsert;
  ToastModule.showToast({
    title: title,
    status: 'success',
    duration: 5000,
  });
};
